import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Modal, ModalBody} from 'reactstrap';
import UploadFile from '../includes/UploadFile';
import * as userActions from "../../actions/user";
import {withRouter} from 'react-router';
import * as uploadReducers from "../../reducers/upload";


class UserNewItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            user_type:'',
            user_name: '',
            user_email: '',
            user_no :'',
            permissionlist:'',
            modal: false,
            redirect: false,
            builderState : false,
            builderUrl : '',
            image_path: null,
            userDet : JSON.parse(window.localStorage.userDet),


        };

        this.toggle = this.toggle.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showBuilder = this.showBuilder.bind(this);
        this.hideBuilder = this.hideBuilder.bind(this);
        this.resetState  = this.resetState.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal,
            image_path: null,
            user_type:'',
            user_name: '',
            user_email: '',
            user_no :''

        });
        this.resetState();
    }
    resetState(){
        this.setState({
            value: '',
            user_type:'',
            user_name: '',
            user_email: '',
            user_no :'',
            permissionlist:'',
            image_path: null,
            userDet : JSON.parse(window.localStorage.userDet),


        });
    }
    getUploadedFile(fileName) {
        console.log(fileName);
        this.setState({
            image_path: fileName
        });
        console.log(this.state.image_path+"========= thi.state.iamgepath");
    }

    showBuilder(e) {
        e.preventDefault();
        this.setState({
            builderState : true
        });
        this.handleSubmit(e, this.state.builderState);
    }

    hideBuilder(e) {
        e.preventDefault();
        this.setState({
            builderState : false
        });
        this.handleSubmit(e, this.state.builderState);
    }

    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });

        if(event.target.value !== '') {
            event.target.classList.remove('is-invalid');
        }
    }

    handleSubmit(e) {
        console.log(this.state);
        //e.preventDefault();
        let formInvalid = 0;

        //Dropdown validation

        if (this.state.user_type === ""){
            formInvalid++;
            document.getElementsByName('user_type')[0].classList.add('is-invalid');
        }

        //Name validation

        if( this.state.user_name === '') {
            formInvalid++;
            document.getElementsByName('user_name')[0].classList.add('is-invalid');
        };

        //* Email validation

        let email=/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

        if (this.state.user_email === ""){
            formInvalid++;
            document.getElementsByName('user_email')[0].classList.add('is-invalid');
        }
        else
        {
            if(email.test(this.state.user_email))
            {
                this.setState({validation: true})
            }
            else{
                formInvalid++;
                document.getElementsByName('user_email')[0].classList.add('is-invalid');
            }
        }




        //*Phone no validation

        if(this.state.user_no === "")
        {
            formInvalid++;
            document.getElementsByName('user_no')[0].classList.add('is-invalid');
        }
        else
        {
            if(isNaN(this.state.user_no))
            {
                formInvalid++;
                document.getElementsByName('user_no')[0].classList.add('is-invalid');
            }
            else
            {
                if (this.state.user_no.length!=10)
                {
                    formInvalid++;
                    document.getElementsByName('user_no')[0].classList.add('is-invalid');
                }

            }
        }

        if( formInvalid === 0) {

            var userData = {
                user_email: this.state.user_email,
                user_name: this.state.user_name,
                user_phone: this.state.user_no,
                user_image: this.state.image_path,
                user_id: this.state.user_id
            };
            console.log(userData);
            let userCreated = this.props.createUser(userData);
            console.log(userCreated);
            //this.props.forceUpdateHandler();
            this.toggle();


        }

    }

    render() {

        return (

            <div className="panel-block new-panel" onClick={this.toggle}>

                <div className="gallery-thumb">
                    <div className="new-button-block">
                        <button className="icon-lib add-button"></button>
                        <p>Add User</p>
                    </div>
                </div>


                <Modal isOpen={this.state.modal} toggle={this.toggle} centered={true} className="vig-mod modal-lg vig-modal user-md create-new-pop" id="vignetModal-user" tabindex="-1" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <ModalBody>
                        <div className="modal-content-wrapper">
                            <div className="modal-header">
                                <form id="company">
                                    <button type="button" className="modal-btn-close" data-dismiss="modal" aria-label="Close" onClick={this.toggle} >✕</button>
                                    <h4 className="modal-title icon-lib title-icon">Add User</h4>
                                </form>
                            </div>
                            <div className="modal-adduser-content">
                                <div className="modal-adduser-content-left">
                                    <div className="tag-block title">
                                        <h5>USER TYPE</h5>
                                        <div className="drop-wrap .modal-adduser-detail">
                                            <div className="select-box select-bg">
                                                <select id="maindesignation" name="user_type" onChange={this.handleInputChange} >
                                                    <option value="select">Select</option>
                                                    <option value="usr">Normal User</option>
                                                    <option value="spu">Admin</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-adduser-detail">
                                        <p>NAME</p>
                                        <div className="input-select">
                                            <input type="user-name" name="user_name" placeholder="User Name" onChange={this.handleInputChange} valid={false} />
                                        </div>
                                    </div>
                                    <div className="modal-adduser-detail">
                                        <p>EMAIL</p>
                                        <div className="input-select">
                                            <input type="email" name="user_email" placeholder="Enter your email address" onChange={this.handleInputChange} valid={false} />
                                        </div>
                                    </div>
                                    <div className="modal-adduser-detail">
                                        <p>PHONE</p>
                                        <div className="input-select">
                                            <input type="number" name="user_no" placeholder="Enter your phone number" onChange={this.handleInputChange} valid={false} />
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-adduser-content-right">
                                    <div className="modal-adduser-detail">
                                        <div className="modal-adduser-img">
                                            <div className="image-up">

                                                {this.state.image_path &&
                                                <img src={this.state.image_path} crossOrigin="anonymous" className="text-center" alt="user"/>
                                                }
                                                {this.state.image_path ===null &&
                                                <img src="assets/images/placeholder.png" alt="default" />
                                                }

                                                <UploadFile getUploadedFile={ this.getUploadedFile.bind(this)} type="add" item_type='USER' fileType="image" />
                                                {(this.state.image_path ===null || this.props.uploadData.loader === true) &&
                                                <div id="progress-bar-wrapper"></div>
                                                }
                                            </div>
                                        </div>
                                        {this.props.uploadData.errors === true &&
                                        <p className="error-message">{this.props.uploadData.errorMessage}</p>
                                        }
                                    </div>
                                </div>
                                <div className="modal-adduser-content-btn">
                                    <div className="modal-btn btn-cancel">
                                        <a href="javascript:void(0);" className="" onClick={this.toggle}>CANCEL</a>
                                    </div>
                                    <div  className="modal-btn btn-create">
                                        <a href="javascript:void(0);" className="" onClick = {(e) => this.handleSubmit(e)}>CREATE</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

            </div>
        );
    }
}

UserNewItem.propTypes = {
    completed: PropTypes.number
}


function mapStateToProps(state) {
    return {
        uploadData : uploadReducers.getUploadData(state)
    };
}
export default  withRouter(connect(mapStateToProps, {
    createUser : userActions.createUser
})(UserNewItem));



// WEBPACK FOOTER //
// ./src/components/user/UserNewItem.js